export default "__VITE_ASSET__30b89ca2__"